import { MapContainer } from 'react-leaflet'
import L from 'leaflet'
import MapData from './MapData'

const LeafletMap = ({ plots, selectedPlot, setSelectedPlot }) => {
    
    return (
        <MapContainer center={[-3, 3]}
            zoom={7}
            minZoom={6}
            maxZoom={10}
            bounds={[[0, 0], [1000, 1000]]} // Adjust bounds as needed
            crs={L.CRS.Simple} // Non-geographic
            style={{ height: '100%', width: '100%' }}>
            <MapData plots={plots} selectedPlot={selectedPlot} setSelectedPlot={setSelectedPlot} />
        </MapContainer>
    )
}

export default LeafletMap


